import { Text, Flex, Button, chakra, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

function Landing() {
  return (
    <Flex 
        flexDir={["column-reverse","column-reverse","column-reverse","row","row"]}
        width="100vw" 
        minHeight="100vh"
        bg="#171717"
        justifyContent="space-around"
        alignItems="center"
    >
        <Flex 
            flexDir="column" 
            width={["80vw","80vw","80vw","600px","600px"]}
            m="30px"
        >
            <Text 
                color="core.white" 
                fontSize={["64px","64px","64px","96px","96px"]}
                fontWeight="800"
                lineHeight="1"
                mb="20px"
            >
                <chakra.span color="core.red">Economist </chakra.span>
                <chakra.span color="core.white">of the </chakra.span>
                <chakra.span color="core.red">Year </chakra.span>
            </Text>
            <Text 
                color="core.white" 
                fontSize="18px" 
                fontWeight="500"
                mt="20px"
                mb="20px"
            >
                The preliminary round of EOTY’22 is an online quiz, based on various topics from the past. The topics revolve around economic theories that have helped in building the modern world.<br></br><br></br>
                Through the quiz, we would be testing your grasping skills, academic intellect and problem-solving abilities to solve questions in the areas of Finance, International Relations, and much more. <br></br><br></br>
                So crack your knuckles coz the clock will be ticking, being agile and astute will get to the next round, worthy of the EOTY name and an experience you will never forget.
            </Text>
            <Flex flexDir="row" mt="20px">
                <Link to="/rules">
                    <Button 
                        fontWeight="800" 
                        mr="24px"
                        bg="core.red"
                        color="core.white"
                        size="lg"
                    >RULES</Button>
                </Link>
                <Link to="leaderboard">
                    <Button 
                        fontWeight="800" 
                        mr="24px"
                        bg="core.white"
                        color="core.dg"
                        size="lg"
                    >LEADERBOARD</Button>
                </Link>
            </Flex>
        </Flex>


        <Flex 
            flexDir="column" 
            width={["80vw","80vw","80vw","600px","600px"]}
            minHeight={["300px","300px","300px","90vh","90vh"]}
            bg="#FF6B6B" 
            m="30px" 
            
            borderRadius="25px">
            <Image margin="auto" src="https://i.imgur.com/eroDeRP.png" width="80%" />
        </Flex>
    </Flex>
  );
}

export default Landing;
